var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.62C20 20.2244 20 19.5266 19.8278 18.9588C19.44 17.6804 18.4395 16.68 17.1611 16.2922C16.5933 16.12 15.8956 16.12 14.5 16.12H9.5C8.10444 16.12 7.40665 16.12 6.83886 16.2922C5.56045 16.68 4.56004 17.6804 4.17224 18.9588C4 19.5266 4 20.2244 4 21.62M16.5 8.12C16.5 10.6053 14.4853 12.62 12 12.62C9.51472 12.62 7.5 10.6053 7.5 8.12C7.5 5.63471 9.51472 3.62 12 3.62C14.4853 3.62 16.5 5.63471 16.5 8.12Z",
    stroke: "#378ED1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBlue);
export default __webpack_public_path__ + "static/media/personBlue.60b3401b9b23fb563066317d24ee0cb4.svg";
export { ForwardRef as ReactComponent };